import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/date-item/date-item.js';
      import {DateItemEvent} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
import {DateItemSize} from '@oicl/openbridge-webcomponents/dist/components/date-item/date-item.js';

      export interface Props {
     size?: DateItemSize;
     disabled?: boolean;
     events?: DateItemEvent[];
     eventCount?: number;
     isToday?: boolean;
     checked?: boolean;
     date?: number
   }

      
  
      export type {DateItemEvent} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
export type {DateItemSize} from '@oicl/openbridge-webcomponents/dist/components/date-item/date-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcDateItem',
  props: {
    size: {},
    disabled: { type: Boolean },
    events: {},
    eventCount: {},
    isToday: { type: Boolean },
    checked: { type: Boolean },
    date: {}
  },
  emits: ["date-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onDateClick: (event: CustomEvent<{date: number, events: DateItemEvent[], isToday: boolean, checked: boolean}>) => emit('date-click', event as CustomEvent<{date: number, events: DateItemEvent[], isToday: boolean, checked: boolean}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-date-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})